import { lesbareFarbeAuf } from '../session/logic'

/**
 * Das Zeichen einer Person: ihr Anfangsbuchstabe auf ihrer Farbe.
 *
 * Die Schriftfarbe wird GERECHNET, nicht aus einer Tabelle geholt — jede
 * Person darf eine eigene Farbe speichern, die in keiner Palette steht.
 */
const ersterBuchstabe = (name: string): string => {
  const sauber = name.trim()
  if (sauber === '') return ''
  // ⚠️ Nicht `name[0]` und nicht `[...name][0]`: das eine zerschneidet
  // Ersatzzeichenpaare, das andere trennt ein kombiniertes Zeichen (A + Ring)
  // von seinem Akzent. Ein Segmentierer liefert das, was ein Mensch als
  // ersten Buchstaben sieht.
  const teiler = new Intl.Segmenter('de-DE', { granularity: 'grapheme' })
  const erstes = [...teiler.segment(sauber)][0]?.segment ?? ''
  return erstes.toLocaleUpperCase('de-DE')
}

export function Avatar({
  name,
  farbe,
  gross = false,
  klein = false,
}: {
  name: string
  farbe: string
  gross?: boolean
  klein?: boolean
}) {
  const buchstabe = ersterBuchstabe(name)
  return (
    <span
      className={`avatar${gross ? ' avatar--gross' : ''}${klein ? ' avatar--klein' : ''}`}
      style={{ background: farbe, color: lesbareFarbeAuf(farbe) }}
      {...(buchstabe ? { title: name } : { 'aria-hidden': true })}
    >
      {buchstabe}
    </span>
  )
}
